import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBreadcrumb } from "../../store/slices/breadCrumbsSlice";

import MobileFavShare from "./MobileFavShare";

function MobileBasicDetail({ selectProduct }) {
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState();
  const selectedVariant = useSelector(
    (state) => state.productDetail.selectedVariant
  );

  useEffect(() => {
    if (selectProduct && selectProduct.length > 0) {
      const firstProduct = selectProduct[0];
      setSelectedProduct(firstProduct);
      dispatch(
        setBreadcrumb({
          verticalID: firstProduct.Vertical_ID,
          verticalName: firstProduct.verticalName,
          categoryID: firstProduct.CategoryID,
          categoryName: firstProduct.categoryName,
          subCategoryID: firstProduct.sc_id,
          subCategoryName: firstProduct.subcategoryName,
          productID: firstProduct.prod_ID,
          productName: firstProduct.prod_name,
        })
      );
    }
  }, [selectProduct, dispatch]);

  const formattedBrandName = selectedProduct?.Manufacturer?.toUpperCase();

  return (
    <div className="w-full flex flex-col items-start justify-start relative px-4 py-3 bg-white-1">
      {/* ❤️ Share / Favorite */}
      <div className="absolute top-3 right-4 z-10">
        <MobileFavShare selectedProduct={selectedProduct} />
      </div>

      {/* 🏷️ Brand Logo or Name */}
      <div className="w-auto h-auto mb-2">
        {selectedProduct?.manufacture_images ? (
          <img
            loading="lazy"
            src={`https://cyclecircle.blr1.cdn.digitaloceanspaces.com/${process.env.REACT_APP_IMAGE_BASE}_MANUFACTURE_IMAGE/${selectedProduct.manufacture_images}`}
            alt={formattedBrandName}
            className="max-w-[35vw] h-8 object-contain"
          />
        ) : (
          <span className="text-[5vw] italic font-extrabold text-black-1/80">
            {formattedBrandName}
          </span>
        )}
      </div>

      {/* 🏍️ Product Name & Tech Info */}
      <div className="flex flex-col gap-1">
        {/* Product Name */}
        {selectedVariant?.prod_name && (
          <h1 className="text-lg sm:text-xl font-bold text-black-1 leading-tight">
            {selectedVariant?.prod_name}
          </h1>
        )}

        {/* Product Tech Info */}
        <p className="text-sm sm:text-base text-gray-700 leading-snug">
          {selectedVariant?.Tech_Data
            ? selectedVariant.Tech_Data
            : selectedProduct?.product_Tech?.map((tech, index) => (
                <span key={index}>
                  {tech}
                  {index !== selectedProduct.product_Tech.length - 1 && ", "}
                </span>
              ))}
        </p>
      </div>
    </div>
  );
}

export default MobileBasicDetail;
